export default __webpack_public_path__ + "static/media/lorenzProjectedSol_pi3_-pi3.4bd3ce11.svg";